// Importing icons
import { ImArrowUpRight2 } from "react-icons/im";
import { AiFillMail } from "react-icons/ai";
import { AiFillInstagram } from "react-icons/ai";
import { AiFillLinkedin } from "react-icons/ai";
import { FaGithub } from "react-icons/fa";

function Contact(){
    const data = [
        {
            id: 0, 
            link: "https://github.com/realdaly/",
            content: "GitHub"
        },
        {
            id: 1, 
            link: "mohammed96218@yahoo.com",
            content: "mohammed96218@yahoo.com"
        },
        {
            id: 2, 
            link: "https://www.instagram.com/realdaly_/",
            content: "Instagram"
        },
        {
            id: 3, 
            link: "https://www.linkedin.com/in/realdaly/",
            content: "LinkedIn"
        }
    ];

    return(
        <div className="w-100 row m-0 g-3">
            {data && 
                <a className="text-white text-decoration-none" href={`${data[0].link}`} target="_blank">
                    <div className="contactContainer bg-secondary rounded">
                        <div><FaGithub size={25} /></div>
                        <div>{data[0].content}</div>
                        <div><ImArrowUpRight2 size={20} /></div>
                    </div>
                </a>
            }

            {data && 
                <a className="text-white text-decoration-none" href={`mailto:${data[1].link}`}>
                    <div className="contactContainer bg-secondary rounded">
                        <div><AiFillMail size={25} /></div>
                        <div>{data[1].content}</div>
                        <div><ImArrowUpRight2 size={20} /></div>
                    </div>
                </a>
            }

            {data && 
                <a className="text-white text-decoration-none" href={data[2].link} target="_blank">
                    <div className="contactContainer bg-secondary rounded">
                        <div><AiFillInstagram size={25} /></div>
                        <div>{data[2].content}</div>
                        <div><ImArrowUpRight2 size={20} /></div>
                    </div>
                </a>
            }

            {data && 
                <a className="text-white text-decoration-none" href={data[3].link} target="_blank">
                    <div className="contactContainer bg-secondary rounded">
                        <div><AiFillLinkedin size={25} /></div>
                        <div>{data[3].content}</div>
                        <div><ImArrowUpRight2 size={20} /></div>
                    </div>
                </a>
            }
        </div>
    )
}

export default Contact